module.exports = __webpack_public_path__ + "img/7.1c9b5deb.png";